export * from './atoms';

import { propertyLayoutAtoms } from './atoms';

export const PropertyComponents = [      
    ...propertyLayoutAtoms,
]